import CategoriesPage from "./Categories";

export default CategoriesPage;
